export default "__VITE_ASSET__BK1UR5ci__"